import React from "react";
import { CustomButton, SidePanelContainer } from "../../../../../../common/components";
import FolderInformation from "./FolderInformation";
import FileInformation from "./FileInformation";
import styles from "./DocumentCenterInformationTab.module.css";
import { environmentAllowed, translate } from "../../../../../../common/providers";
import { compareInsensitiveCaseString } from "../../../../../../common/utils";
import { FILE_TYPES } from "../../../../../../common/constants/file-types";
import { DOCUMENT_STATUS } from "../../../../constants/constants";

export default function DocumentCenterInformationTab({
	id,
	hasActionPermission,
	onEdit,
	onSetDirectoryId,
	onSetSelectedDocInformation,
	selectedDocInformation,
	status,
	type,
}) {
	return (
		<SidePanelContainer className={styles.tab}>
			<div className={styles.header}>
				<span className={styles.tab__title}>{translate("document-center.side-panel.information")}</span>
				{type !== "folder" && hasActionPermission && environmentAllowed(["veolia"]) && (
					<CustomButton variant="contained" onClick={onEdit}>
						{translate("common:btn.edit")}
					</CustomButton>
				)}
			</div>
			{(type === "folder" && <FolderInformation directoryId={id} />) || (
				<FileInformation
					docId={id}
					isOngoing={DOCUMENT_STATUS.IN_PROGRESS === status || DOCUMENT_STATUS.PENDING === status}
					selectedDocInformation={selectedDocInformation}
					unsupported={compareInsensitiveCaseString(type, FILE_TYPES.UNSUPPORTED)}
					onSetDirectoryId={onSetDirectoryId}
					onSetSelectedDocInformation={onSetSelectedDocInformation}
				/>
			)}
		</SidePanelContainer>
	);
}
